import { render, staticRenderFns } from "./TheFooterItemTitle.vue?vue&type=template&id=358102b1&scoped=true"
import script from "./TheFooterItemTitle.vue?vue&type=script&lang=js"
export * from "./TheFooterItemTitle.vue?vue&type=script&lang=js"
import style0 from "./TheFooterItemTitle.vue?vue&type=style&index=0&id=358102b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358102b1",
  null
  
)

export default component.exports